// @flow
import { connect } from 'react-redux';

// DEPRECATED

// $FlowFixMe
export default (header: string) => connect(
  (state) => {
    const projectName = state.dealer.project_name;

    return ({
      header,
      title: projectName ? `${header} - ${state.dealer.project_name}` : header,
    });
  },
);
